export default __webpack_public_path__ + "static/media/Do-documentation.957fa201.md";